import { DateTime } from 'luxon';

export const fromJSDateToISODate = (date: Date): string => {
    return DateTime.fromJSDate(date).toISODate() as string;
};
